import { render, staticRenderFns } from "./CarouselAnimation.vue?vue&type=template&id=2c2641e2"
import script from "./CarouselAnimation.vue?vue&type=script&lang=js"
export * from "./CarouselAnimation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports